import * as React from 'react';
import './sign-in.scss';
import { SafetyCertificateOutlined, ThunderboltOutlined, LineChartOutlined, LockOutlined } from '@ant-design/icons';
import darkLogo from 'assets/images/logo-main.png';
import lightLogo from 'assets/images/light-logo.png';
import { VERSION } from 'core/constants/constants';

interface Props {
    children: React.ReactNode;
}

const HIGHLIGHTS = [
    { icon: <SafetyCertificateOutlined />, title: 'ورود امن', text: 'احراز هویت دو مرحله‌ای و نشست رمزنگاری‌شده' },
    { icon: <ThunderboltOutlined />, title: 'پردازش سریع', text: 'رسیدگی آنی به سفارش‌ها و تراکنش‌های کاربران' },
    { icon: <LineChartOutlined />, title: 'گزارش لحظه‌ای', text: 'پایش موجودی‌ها و گردش مالی در یک نگاه' },
];

export const SignIn: React.FC<Props> = ({ children }) => {
    return (
        <div className="pmx-signin">
            <main className="form-panel">
                <div className="content">
                    <img className="mobile-logo" src={darkLogo} alt="پی ام ایکس چنج" />
                    {children}
                    <footer className="signin-footer">
                        <span>پنل مدیریت پی ام ایکس چنج</span>
                    </footer>
                </div>
            </main>

            <aside className="brand-panel" aria-hidden="true">
                <div className="banner">
                    <div className="grid-pattern" />
                    <div className="orb orb-a" />
                    <div className="orb orb-b" />

                    <div className="box">
                        <header className="box-head">
                            <img className="brand-logo" src={lightLogo} alt="" />
                            <span className="badge">
                                <LockOutlined />
                                پنل مدیریت
                            </span>
                        </header>

                        <div className="box-body">
                            <h2>
                                مدیریت صرافی
                                <br />
                                در یک پنل یکپارچه
                            </h2>
                            <p className="lead">
                                سفارش‌ها، تراکنش‌ها، موجودی‌ها و کاربران — همه در یک جا، با دسترسی کنترل‌شده.
                            </p>

                            <ul className="highlights">
                                {HIGHLIGHTS.map((item) => (
                                    <li key={item.title}>
                                        <span className="icon">{item.icon}</span>
                                        <span className="texts">
                                            <strong>{item.title}</strong>
                                            <small>{item.text}</small>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <footer className="box-foot">
                            <span>دسترسی محدود به کاربران مجاز</span>
                            <span className="version">نسخه {VERSION}</span>
                        </footer>
                    </div>
                </div>
            </aside>
        </div>
    );
};
